import React, { createContext, useContext } from "react";
import { useUserPreferences } from "../hooks/usePersistedState";

const UserPreferencesContext = createContext(null);

export function UserPreferencesProvider({ children }) {
  const preferences = useUserPreferences();

  return (
    <UserPreferencesContext.Provider value={preferences}>
      {children}
    </UserPreferencesContext.Provider>
  );
}

export function usePreferences() {
  const context = useContext(UserPreferencesContext);
  if (!context) {
    throw new Error(
      "usePreferences deve ser usado dentro de UserPreferencesProvider"
    );
  }
  return context;
}

export default UserPreferencesContext;
